import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import moment from 'moment'
import { getLocaleByLang } from 'locale'
import sweetalert from 'sweetalert2'
import {
  setLang
} from 'store/redux/locale'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserSelector } from 'selectors/currentUser'

sweetalert.setDefaults({
  confirmButtonClass: 'btn btn-primary',
  cancelButtonClass: 'btn btn-default',
  buttonsStyling: false
})

const LangProvider: React.FC = () => {
  const dispatch = useDispatch()

  const intl = useIntl()

  const currentUser = useSelector<any, any>(currentUserSelector)

  const lang = currentUser?.settings?.lang

  useEffect(() => {
    if (lang) {
      const localeName = getLocaleByLang(lang)

      sweetalert.setDefaults({
        confirmButtonText: intl.formatMessage({ id: 'OK' })
      })

      moment.locale(localeName)

      dispatch(setLang({
        lang
      }))
    }
  }, [lang])

  return null
}

export default LangProvider